import React from 'react';
import styled from 'styled-components';
import { screenXsMax, spacer16, spacer40, Type } from '@spotify-internal/encore-web';
import { useT } from '@mrkt/features/i18n';
import { Box } from '../../ui';
import { FAQItem, Variant } from './FAQItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var HelpFAQComponent = styled(Box).withConfig({
  displayName: "HelpFAQ__HelpFAQComponent",
  componentId: "sc-19s3hh0-0"
})([""]);
var Headline = styled(Type.h1).attrs({
  variant: Type.heading2,
  weight: Type.bold
}).withConfig({
  displayName: "HelpFAQ__Headline",
  componentId: "sc-19s3hh0-1"
})(["padding-top:", ";padding-bottom:", ";"], spacer16, spacer40);
var FAQWrapper = styled.div.withConfig({
  displayName: "HelpFAQ__FAQWrapper",
  componentId: "sc-19s3hh0-2"
})(["display:flex;flex-flow:row wrap;justify-content:space-between;align-content:flex-start;width:100%;@media (max-width:", "){flex-flow:column;}"], screenXsMax);
export var HelpFAQ = function HelpFAQ(_ref) {
  var headline = _ref.headline,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  var t = useT();
  return (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/_jsxs(HelpFAQComponent, {
    "data-testid": "help-faq",
    children: [/*#__PURE__*/_jsx(Headline, {
      children: headline || t('FRODOR_HELP_FAQ_TOP_ARTICLES', 'Top help articles', 'Headline for the top help articles section')
    }), /*#__PURE__*/_jsx(FAQWrapper, {
      children: (items === null || items === void 0 ? void 0 : items.length) && items.map(function (item, key) {
        return item && /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsx(FAQItem, {
            hit: item,
            variant: Variant.SPEED_DIAL
          })
        }, key);
      })
    })]
  }) || /*#__PURE__*/_jsx(_Fragment, {});
};